/*--############################################################################
# Filename : HR04_009RPT.vue
# Description : 인사관리 > 근태 현황 > 52시간 확인 현황
# Date :2025-09-10
# Author : 권지안
################################################################################*/
<template>
  <!-- 조회조건 -->
  <div class="flex justify-between items-center w-full overflow-y-hidden">
    <PageName></PageName>
    <div class="flex justify-center mr-9 space-x-2 pr-5">
      <button @click="searchButton" class="button search md:w-auto w-14">
        조회
      </button>
      <button @click="excelButton" class="button save w-auto excel">
        엑셀
      </button>
    </div>
  </div>
  <div class="grid grid-cols-2 grid-rows-1 justify-between bg-gray-200 rounded-lg h-20 items-start z-10">
    <div class="grid grid-cols-1 grid-rows-2 h-full mt-1">
      <Datepicker3
        class=""
        @endMonth="endMonth"
        @endYear="endYear"
        @startMonth="startMonth"
        @startYear="startYear"
        @excelDate="excelDate">
      </Datepicker3>
      <div class="flex items-center text-base text-nowrap font-semibold pl-16">
        사원명
        <div>
          <label for="sum" class="font-normal">
            <input
              class="ml-5"
              type="text"
              id="chargerNm"
              v-model="chargerNm"
              @input="onChargerInput">
          </label>
        </div>
      </div>
    </div>
    <div class="flex items-start">
      <PickStorePlural
        @lngStoreCodes="lngStoreCodes"
        @lngStoreGroup="lngStoreGroup"
        @lngStoreAttrs="lngStoreAttrs"
        @excelStore="excelStore"
        >
      </PickStorePlural>
    </div>
    <div></div>
  </div>
  <!-- 조회조건 -->
  <!-- 그리드 영역 -->
  <div class="w-full h-[85%]">
    <Realgrid
      :progname="'HR04_009RPT_VUE'"
      :progid="1"
      :rowData="rowData"
      :reload="reload"
      :setFooter="true"
      :setFooterColID="setFooterColID"
      :setFooterExpressions="setFooterExpressions"
      :timeColumns="['strPWTime','strPWWeekAvg', 'strRWTime', 'strRWWeekAvg', 'strRGapTime', 'strRGapTimeAvg', 'strEWTime', 'strEWWeekAvg', 'strEGapTime', 'strEGapTimeAvg']"
      :documentTitle="'HR04_009RPT'"
      :documentSubTitle="documentSubTitle"
      :exporttoExcel="exportExcel"
      :mergeColumns2="true"
      :mergeColumnGroupSubList2="[
        ['strPWTime','strPWWeekAvg'], ['strRWTime','strRWWeekAvg'], ['strRGapTime','strRGapTimeAvg'],
        ['strEWTime','strEWWeekAvg'], ['strEGapTime','strEGapTimeAvg'],
      ]"
      :rowStateeditable="false"
      :mergeColumnGroupName2="['스케줄', '실적', '차이(실적-스케줄)', '예상', '차이(예상-스케줄)']">
    </Realgrid>
  </div>
  <!-- 그리드 영역 -->
</template>

<script setup>
import { getConfirmStatus } from "@/api/mihr";
/**
 *  해당연월 컴포넌트
 *  */

import Datepicker3 from "@/components/Datepicker3.vue";
/**
 *  페이지명 자동 입력 컴포넌트
 *  */

import PageName from "@/components/pageName.vue";
/**
 * 	다중 매장 선택 컴포넌트
 */

import PickStorePlural from "@/components/pickStorePlural.vue";
/**
 * 	그리드 생성
 */

import Realgrid from "@/components/realgrid.vue";
/**
 *  페이지로그 자동 입력
 *  */

import { insertPageLog } from "@/customFunc/customFunc";
/**
 *  경고창 호출 라이브러리
 *  */

import Swal from "sweetalert2";
/*
 * 공통 표준  Function
 */

import { onMounted, ref } from "vue";
/**
 *  Vuex 상태관리 및 로그인세션 관련 라이브러리
 */

import { useStore } from "vuex";

/**
 * 	화면 Load시 실행 스크립트
 */

onMounted(async () => {
  const pageLog = await insertPageLog(store.state.activeTab2);
});

const setFooterColID = ref([
   "strStoreName"
  ,"strArea"
  ,"strWorkCls"
  ,"lngEmpID"
  ,"strChargerName"
  ,"strPWTime"
  ,"strPWWeekAvg"
  ,"strRWTime"
  ,"strRWWeekAvg"
  ,"strRGapTime"
  ,"strRGapTimeAvg"
  ,"strEWTime"
  ,"strEWWeekAvg"
  ,"strEGapTime"
  ,"strEGapTimeAvg"
]);

const setFooterExpressions = ref([
   "custom"
  ,"custom"
  ,"custom"
  ,"custom"
  ,"custom"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
  ,"avg"
]);

const reload = ref(false);
const rowData = ref([]);
const afterSearch = ref(false);
const selectedstartYear = ref();
const selectedendYear = ref();
const selectedstartMonth = ref();
const selectedendMonth = ref();

/**
 * 	종료 월
 */

const endMonth = (e) => {
  //comsole.log(e);
  selectedendMonth.value = e;
};

/**
 * 	시작 년
 */

const startYear = (e) => {
  //comsole.log(e);
  selectedstartYear.value = e;
};

/**
 * 	시작 월
 */

const startMonth = (e) => {
  //comsole.log(e);
  selectedstartMonth.value = e;
};

/**
 * 	종료 년
 */

const endYear = (e) => {
  //comsole.log(e);
  selectedendYear.value = e;
};

const store = useStore();

const chargerNm = ref("");

function onChargerInput(e) {
  // console.log("현재 입력값:", e.target.value);
  initGrid();
}

/**
 *  조회 함수
 */

const searchButton = async () => {
  if (
    selectedstartYear.value == null ||
    selectedstartMonth.value == null ||
    selectedendYear.value == null ||
    selectedendMonth.value == null
  ) {
    Swal.fire({
      title: "날짜를 선택하세요.",
      icon: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "확인",
    });
    return;
  }

  try {
    store.state.loading = true;
    initGrid();
    
    reload.value = !reload.value;
    
    // console.log(chargerNm.value);
    
    /* 선택한 매출 시작일자 */
    const startMonth = `${selectedstartYear.value}-${String(
      selectedstartMonth.value
    ).padStart(2, "0")}-01`;

    /* 선택한 매출 종료일자 */
    const endMonth = `${selectedendYear.value}-${String(
      selectedendMonth.value
    ).padStart(2, "0")}-01`;
    
    const res = await getConfirmStatus(
      selectedGroup.value,
      selectedStores.value,
      startMonth,
      endMonth,
      chargerNm.value,
    );

    // console.log(res);

    rowData.value = res.data.confirmStatus;
    afterSearch.value = true;

  } catch (error) {
    afterSearch.value = false;
  } finally {
    store.state.loading = false;
  }
};

const selectedGroup = ref();
const selectedStores = ref();
const selectedStoreAttrs = ref();

/**
 * 페이지 매장 그룹 세팅
 */

const lngStoreGroup = (e) => {
  //comsole.log(e);
  selectedGroup.value = e;
};
/**
 * 페이지 매장 코드 세팅
 */

const lngStoreCodes = (e) => {
  selectedStores.value = e;

  if (selectedStores.value.includes(",")) {
    // 콤마가 있으면 여러 값 → 0으로
    selectedStores.value = 0;
  } else {
    // 단일 값이면 숫자로 변환
    selectedStores.value = Number(selectedStores.value) || 0;
  }

  //comsole.log(e);
};

/**
 * 페이지 매장 분류 세팅
 */

const lngStoreAttrs = (e) => {
  selectedStoreAttrs.value = e;
  //comsole.log(e);
};

/**
 * 그리드 초기화
 */

const initGrid = () => {
  if (rowData.value.length > 0) {
    rowData.value = [];
  }
};

const exportExcel = ref(false);
const selectedExcelStore = ref("");
const selectedExcelDate = ref("");
const documentSubTitle = ref("");

/**
 * 엑셀용 매장 세팅 함수
 */

const excelStore = (e) => {
  selectedExcelStore.value = e;
};

/**
 * 엑셀용 일자 세팅 함수
 */

const excelDate = (e) => {
  selectedExcelDate.value = e;
};

/**
 * 엑셀 내보내기 함수
 */

const excelButton = () => {
  documentSubTitle.value =
    selectedExcelDate.value + "\n" + selectedExcelStore.value;
  exportExcel.value = !exportExcel.value;
};

</script>

<style></style>
